import { IVariablesTree } from "../../interfaces/variable.interface";

const ActionTypes = {
  GET_VARIABLE_SUBTREE: '[Variables-Subtrees] Get Variable Subtree',
  GET_VARIABLE_SUBTREE_SUCCESS: '[Variables-Subtrees] Get Variable Subtree Success',
  GET_VARIABLE_SUBTREE_FAIL: '[Variables-Subtrees] Get Variable Subtree Fail',

  RESET_VARIABLE_SUBTREE: '[Variable-Subtree] Reset Variable Subtree',


  SEARCH_SUBTREE_VARIABLE: '[Variables] Search Subtree Variable',
  SEARCH_SUBTREE_VARIABLE_SUCCESS: '[Variables] Search Subtree Variable',
  SEARCH_SUBTREE_VARIABLE_FAIL: '[Variables] Search Subtree Variable',
}

export class GetVariableSubtree {
  static type = ActionTypes.GET_VARIABLE_SUBTREE;

  constructor(public payload: string) {}
}

export class GetVariableSubtreeSuccess {
  static type = ActionTypes.GET_VARIABLE_SUBTREE_SUCCESS;

  constructor(public payload: IVariablesTree) {}
}

export class GetVariableSubtreeFail {
  static type = ActionTypes.GET_VARIABLE_SUBTREE_FAIL;
}

export class ResetVariableSubtree {
  static type = ActionTypes.RESET_VARIABLE_SUBTREE;
}

export class SearchSubtreeVariable {
  static type = ActionTypes.SEARCH_SUBTREE_VARIABLE;

  constructor(public payload: {filterTreeName: string, input: string}) {}
}

export class SearchSubtreeVariableSuccess {
  static type = ActionTypes.SEARCH_SUBTREE_VARIABLE_SUCCESS;

  constructor(public payload: any, public metadata: string) {}
}

export class SearchSubtreeVariableFail {
  static type = ActionTypes.SEARCH_SUBTREE_VARIABLE_FAIL;
}